import { render, staticRenderFns } from "./RecommendedItem.vue?vue&type=template&id=97942e48&scoped=true"
import script from "./RecommendedItem.vue?vue&type=script&lang=js"
export * from "./RecommendedItem.vue?vue&type=script&lang=js"
import style0 from "./RecommendedItem.vue?vue&type=style&index=0&id=97942e48&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97942e48",
  null
  
)

export default component.exports